export const theme = {
  light: {
    foreground: '#252525',
    background: '#121212',
    primary: {
      default: '#00B2E3',
      hover: '#008EB6',
      pressed: '#008EB6',
      disabled: '#808080'
    },
    fontColor: '#000000'
  },
  dark: {
    foreground: '#252525',
    background: '#121212',
    primary: {
      default: '#0085CA',
      hover: '#008EB6',
      pressed: '#008EB6',
      disabled: '#808080'
    },
    fontColor: '#FFFFFF'
  }
}
